import { Link } from 'react-router-dom'

const NotFound: React.FC = () => {
    return (
        <div className="container-fluid">
            <div className="text-center p-5">
                <div className="error mx-auto" data-text={404}>
                    404
                </div>
                <p className="lead mb-5">Page Not Found</p>
                <p className="mb-0">
                    It looks like you found a glitch in the matrix...
                </p>
                <Link to="/" className="btn btn-secondary mt-5">
                    ← Back to Dashboard
                </Link>
            </div>
        </div>
    )
}

export default NotFound
